import { NextSeoProps } from 'next-seo';

import { SeoFragment } from 'types/api/dato-operations.types';

interface NormalizedTag {
  [key: string]: string;
}

const normalizeTag = ({
  tag,
  attributes,
  content,
}: SeoFragment): NormalizedTag => {
  if (tag === 'title' && content) {
    return {
      [tag]: content,
    };
  }
  if (tag === 'meta' && attributes) {
    if ('property' in attributes) {
      return {
        [attributes.property]: attributes?.content,
      };
    } else {
      return {
        [attributes.name]: attributes?.content,
      };
    }
  }
  return {};
};

const tagsToLookup = (cmsSeoTags: Array<SeoFragment>) =>
  cmsSeoTags.reduce<{
    [key: string]: string;
  }>((memo, tag) => {
    return { ...memo, ...normalizeTag(tag) };
  }, {});

export const convertToNextSeoProps = (
  cmsSeoTags: Array<SeoFragment>,
): NextSeoProps => {
  const tags = tagsToLookup(cmsSeoTags);
  const robotsDirectives =
    tags['robots']
      ?.toLowerCase()
      .split(',')
      .map((s) => s.trim()) || [];
  return {
    title: tags['title'],
    description: tags['description'],
    openGraph: {
      site_name: tags['og:site_name'],
      locale: tags['og:locale'],
      images: [
        {
          url: tags['og:image'],
          width: Number(tags['og:image:width']),
          height: Number(tags['og:image:height']),
          alt: tags['og:image:alt'],
        },
      ],
      title: tags['title'],
      description: tags['description'],
    },
    twitter: {
      handle: tags['twitter:site'],
      site: tags['twitter:site'],
      cardType: tags['twitter:card'],
    },
    noindex: robotsDirectives.includes('noindex'),
    nofollow: robotsDirectives.includes('nofollow'),
  };
};

export const noIndexUnlistedEvents = (unlisted = false): NextSeoProps =>
  unlisted
    ? {
        noindex: true,
        nofollow: true,
      }
    : {};
